import type { ReactNode } from "react";
import { Link } from "@tanstack/react-router";
import { Button } from "@/components/ui/button";
import { ChevronRight } from "lucide-react";
import { CinematicHero } from "@/components/site/CinematicHero";
import type { FocalPoint } from "@/lib/media-taxonomy";

interface PageHeroProps {
  title: string;
  subtitle: ReactNode;
  imageSrc: string;
  /** Optional responsive candidates, e.g. `${small} 640w, ${large} 1024w`. */
  imageSrcSet?: string | undefined;
  imageAlt: string;
  imageFocal?: FocalPoint | null | undefined;
  overline?: string;
  cta?: { label: string; to: string };
  secondaryCta?: { label: string; to: string };
}

export function PageHero({
  title,
  subtitle,
  imageSrc,
  imageSrcSet,
  imageAlt,
  imageFocal,
  overline = "Gopro Projects Limburg",
  cta,
  secondaryCta,
}: PageHeroProps) {
  return (
    <CinematicHero
      title={title}
      subtitle={subtitle}
      overline={overline}
      imageSrc={imageSrc}
      imageSrcSet={imageSrcSet}
      imageAlt={imageAlt}
      imageFocal={imageFocal}
    >
      {cta || secondaryCta ? (
        <div className="flex flex-wrap gap-3">
          {cta && (
            <Button asChild size="lg" className="bg-secondary text-secondary-foreground hover:bg-secondary/90">
              <Link to={cta.to}>{cta.label}</Link>
            </Button>
          )}
          {secondaryCta && (
            <Button
              asChild
              size="lg"
              variant="outline"
              className="border-primary-foreground/60 bg-transparent text-primary-foreground hover:bg-primary-foreground/10 hover:text-primary-foreground"
            >
              <Link to={secondaryCta.to}>
                {secondaryCta.label} <ChevronRight className="ml-1 h-4 w-4" />
              </Link>
            </Button>
          )}
        </div>
      ) : null}
    </CinematicHero>
  );
}
